import { createFileRoute, Outlet } from '@tanstack/react-router'
import { InventoriesPage } from '~/components/routes/inventories/inventories-page'
import { INVENTORIES_READ } from '~/components/routes/inventories/permissions'
import { withRoutePermissions } from '~/utils/rbac'
import { inventoriesSearchSchema } from './-search-schema'

function InventoriesRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <InventoriesPage
        search={search}
        navigate={navigate}
        onOpenStore={(storeId) =>
          void navigate({ to: '/inventories/$storeId', params: { storeId }, search: true })
        }
      />
      {/* Panneau latéral d'une boutique (route imbriquée /inventories/$storeId). */}
      <Outlet />
    </>
  )
}

export const Route = createFileRoute('/_authenticated/inventories')({
  component: InventoriesRoute,
  // Lisible avec l'un OU l'autre des droits de lecture d'inventaire — les mêmes que l'API.
  staticData: { permission: INVENTORIES_READ },
  validateSearch: inventoriesSearchSchema,
})

withRoutePermissions(Route)
